import React, { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useNavigate, useLocation } from 'react-router-dom';
import { getUserPermissionListDispatch } from 'reducers/UserReducer';
import { MatxLoading } from 'app/components';

export const AppInitializer = ({ children }) => {
	const dispatch = useDispatch();
	const navigate = useNavigate();
	const location = useLocation();
	const { loginInfo } = useSelector((state) => state.user);
	const { userPermissions } = useSelector((state) => state.user);

	const isPublicRoute = location.pathname.startsWith('/session');

	useEffect(() => {
		if (!loginInfo) {
			console.log('No login info found');
			if (!isPublicRoute) {
				navigate('/session/signin', { replace: true, state: { from: location } });
			}
		} else {
			console.log('Login info found:', loginInfo);
			if (!userPermissions) {
				dispatch(getUserPermissionListDispatch(loginInfo.token));
			}
		}
	}, [loginInfo, userPermissions, isPublicRoute]);

	if (!isPublicRoute && (!loginInfo || !userPermissions)) {
		return <MatxLoading />;
	}

	return <>{children}</>;
};


export default AppInitializer;
